import { Link } from "react-router-dom";
import "../styles/unsubscribepage.css";

export default function Unsubscribe() {
  return (
    <div className="unsubscribe-wrapper">
      <h1 className="unsubscribe-title">Du wurdest vom Newsletter abgemeldet!.</h1>
      <p className="unsubscribe-text">
        Schade, dass du nicht mehr dabei bist. Falls du deine Meinung änderst, kannst du dich jederzeit wieder anmelden.
      </p>

      <div className="unsubscribe-buttons">
        <Link to="/" className="unsubscribe-button">
          Zur Anmeldung zurück
        </Link>

        <a
          href="https://learned-marimba-02d.notion.site/1ef2c9f6416780ec8995d059733f2e20?pvs=105" 
          target="_blank"
          rel="noopener noreferrer"
          className="unsubscribe-feedback-button"
        >
          Feedback geben
        </a>
      </div>
    </div>
  );
}
